import { UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button } from 'components/atoms';
import { CSSProperties, ReactNode } from 'react';
import { PiDotsSixVertical } from 'react-icons/pi';
import { animateLayoutChanges } from 'utils/dnd/dndUtilities';

export interface ITableDraggableColumns<T> {
  label: ReactNode;
  renderCell: (node: T) => ReactNode;
}

interface ITableDraggableSortableRowProps<T extends { id: UniqueIdentifier }> {
  item: T;
  columns: ITableDraggableColumns<T>[];
  draggable?: boolean;
}

const TableDraggableSortableRow = <T extends { id: UniqueIdentifier }>({
  item,
  columns,
  draggable,
}: ITableDraggableSortableRowProps<T>) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item.id, animateLayoutChanges });

  const style: CSSProperties = {
    // transform: `translate(0px, ${transform?.y}px)`,
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.7 : 1,
  };

  return (
    <div className='table-draggable-row' ref={setNodeRef} style={style}>
      {draggable && (
        <div className='table-draggable-cell'>
          <Button
            isClear
            onlyIcon
            size='compact'
            {...attributes}
            {...listeners}>
            <Button.Icon icon={<PiDotsSixVertical />} />
          </Button>
        </div>
      )}
      {columns.map((column, key) => (
        <div className='table-draggable-cell' key={key}>
          {column.renderCell(item)}
        </div>
      ))}
    </div>
  );
};

export default TableDraggableSortableRow;
